import styles from './Brand.module.css';

export const BRAND_NAME = 'Jamie’s Nails Pro';

export interface BrandWordmarkProps {
  /** primary: large stacked lockup; compact: single line for headers. */
  readonly variant?: 'primary' | 'compact';
  /** mono: black for print labels and monochrome contexts. */
  readonly tone?: 'brand' | 'mono';
}

/**
 * Signature wordmark (docs/02): “Jamie’s” in script with NAILS PRO as a small tracked
 * supporting line. The accessible name is always “Jamie’s Nails Pro”. If the script
 * font fails to load, the text still renders in the fallback stack — never a blank.
 */
export function BrandWordmark({ variant = 'primary', tone = 'brand' }: BrandWordmarkProps) {
  return (
    <span
      className={`${styles.wordmark} ${styles[variant]} ${tone === 'mono' ? styles.mono : ''}`}
      role="img"
      aria-label={BRAND_NAME}
    >
      <span className={styles.script} aria-hidden="true">
        Jamie’s
      </span>
      <span className={styles.caps} aria-hidden="true">
        NAILS PRO
      </span>
    </span>
  );
}

/** Small-icon variant: an original J flourish inside a nail outline. */
export function BrandIcon({
  className,
  tone = 'brand',
}: {
  className?: string;
  tone?: 'brand' | 'mono';
}) {
  const stroke = tone === 'mono' ? '#000000' : '#FFFDFC';
  return (
    <svg
      viewBox="0 0 64 64"
      className={`${styles.icon} ${className ?? ''}`}
      aria-hidden="true"
      focusable="false"
    >
      {tone === 'brand' ? <rect width="64" height="64" rx="14" fill="#693653" /> : null}
      <g fill="none" stroke={stroke} strokeLinecap="round" strokeLinejoin="round">
        <path
          strokeWidth="2.6"
          d="M 17 32 C 17 17.48 24.8 10 32 10 C 39.2 10 47 17.48 47 32 L 47 46.08 Q 47 54 32 54 Q 17 54 17 46.08 Z"
        />
        <path strokeWidth="3" d="M 24.5 22.5 C 29 19 37 18.5 41.5 20.5" />
        <path
          strokeWidth="3"
          d="M 36 21 C 36.6 28 36.8 34 35.5 38.5 C 34 43.5 28.5 45.5 25.5 41.5 C 24.2 39.6 25.2 37.4 27.4 37.8"
        />
      </g>
    </svg>
  );
}
